var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('dashboard')))]),_c('DDSDashboard',{on:{"card-clicked":_vm.handleCardClick}}),_c('AdminDueDiligenceReportsComponent',{ref:"reportsComponent"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }